import { Bitmap, BitmapData, MovieClip } from "../runtime";
import { EFF_strike0, EFF_strike1, EFF_strike2, EFF_strike3 } from "./assets";

/** Slash sprite per power: 0-3 are sword levels, 4 the death cross, 5 an enemy hit. */
const STRIKE_SPRITES: readonly (new (w: number, h: number) => BitmapData)[] = [
  EFF_strike0,
  EFF_strike1,
  EFF_strike2,
  EFF_strike3,
  EFF_strike3,
  EFF_strike1,
];

/**
 * One additive slash flash. It stretches from a stubby start towards a wide,
 * flat target scale while flickering between 0.65x and 1.15x width every other
 * frame, then fades over ten frames from frame 8 onwards. Powers below 4 spin
 * at a random rate from a random angle; 4 and 5 use the angle they are given.
 */
export class Strike extends MovieClip {
  private readonly targetScaleX: number;
  private readonly targetScaleY: number;
  private readonly rotSpeed: number;
  private life = 0;
  private alphaCurrent = 100;
  private fullSize = true;
  private sizeCounter = 0;
  private sX = 0;
  private sY = 0;

  constructor(power = 0, x = 0, y = 0, forcedAngle = 0) {
    super();
    const strikeBit = new Bitmap(new STRIKE_SPRITES[power](0, 0));
    strikeBit.x = strikeBit.width * -0.5;
    strikeBit.y = strikeBit.height * -0.5;
    this.addChild(strikeBit);
    this.sX = power * 0.5 + 1;
    this.sY = power * 0.5 + 2;
    this.blendMode = "add";
    this.x = x;
    this.y = y;
    this.scaleX = this.sX;
    this.scaleY = this.sY;
    this.targetScaleX = power + 4.5;
    this.targetScaleY = power * 0.5 + 0.5;
    if (power >= 4) {
      this.rotSpeed = 0;
      this.rotation = forcedAngle;
      strikeBit.smoothing = true;
    } else {
      this.rotSpeed = (Math.round(Math.random() * 100) - 50) * 0.05;
      this.rotation = Math.floor(Math.random() * 360);
    }
  }

  /** True once the flash has faded out. */
  update(): boolean {
    let faded = false;
    ++this.life;
    ++this.sizeCounter;
    if (this.sizeCounter === 2) {
      this.fullSize = !this.fullSize;
      this.sizeCounter = 0;
    }
    this.rotation += this.rotSpeed;
    this.sX += (this.targetScaleX - this.sX) * 0.07;
    this.sY += (this.targetScaleY - this.sY) * 0.07;
    this.scaleX = this.fullSize ? this.sX * 1.15 : this.sX * 0.65;
    this.scaleY = this.sY;
    if (this.life > 8) {
      this.alphaCurrent -= 10;
      this.alpha = this.alphaCurrent * 0.01;
      if (this.alphaCurrent === 0) {
        faded = true;
      }
    }
    return faded;
  }
}
